export default __webpack_public_path__ + "static/media/menu.5b76b159.svg";